module.exports = {"menu":{"main":{"generateSection":{"title":"Generate","queryString":"Enter Query String","searchReport":"Generate Search Report"},"canvasSection":{"title":"Canvas","new":"New Canvas","open":"Open Saved Search","add":"Add to Canvas","save":"Save / Save As","upload":"Upload to Canvas","download":"Download Canvas","share":"Share Strategy"}},"profile":{"userSection":{"title":"Profile","preferences":"Preferences","tour":"Tutorial"},"companySection":{"title":"2DSearch","helpPage":"Help with 2D Searching","demoRequest":"Request  Demo","about":"About"}}}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en-uk/menu.json
// module id = Ob03
// module chunks = 1